import { useState } from 'react';
import { usePlanElementForm } from '@/hooks/usePlanElementForm';

export interface PlanMalElement {
  id: number;
  kategori_id: number;
  type: 'overskrift' | 'hendelse' | 'musikk_placeholder';
  navn: string;
  varighet_minutter: number | null;
  parent_id: number | null;
  rekkefølge: number;
  beskrivelse?: string;
  før_produksjonsstart?: boolean;
}

export const usePlanMalDialog = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState<'overskrift' | 'hendelse' | 'musikk_placeholder'>('overskrift');
  const [editingElement, setEditingElement] = useState<PlanMalElement | null>(null);
  const [currentParentId, setCurrentParentId] = useState<number | null>(null);
  const formState = usePlanElementForm();

  const openOverskriftDialog = (parentId: number | null = null) => {
    setDialogMode('overskrift');
    setCurrentParentId(parentId);
    setEditingElement(null);
    formState.resetForm();
    setDialogOpen(true);
  };

  const openHendelseDialog = (parentId: number) => {
    setDialogMode('hendelse');
    setCurrentParentId(parentId);
    setEditingElement(null);
    formState.resetForm();
    setDialogOpen(true);
  };

  const openMusikkPlaceholderDialog = (parentId: number) => {
    setDialogMode('musikk_placeholder');
    setCurrentParentId(parentId);
    setEditingElement(null);
    formState.resetForm();
    setDialogOpen(true);
  };

  const openEditDialog = (element: PlanMalElement) => {
    setDialogMode(element.type);
    setEditingElement(element);
    formState.loadFromElement(element as any);
    setCurrentParentId(element.parent_id);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setEditingElement(null);
    formState.resetForm();
  };

  return {
    dialogOpen,
    dialogMode,
    editingElement,
    currentParentId,
    formState,
    openOverskriftDialog,
    openHendelseDialog,
    openMusikkPlaceholderDialog,
    openEditDialog,
    closeDialog,
    setDialogOpen,
  };
};

